import {
    BUSINESSPROCESSDESIGNER_DELETE_BUSINESSPROCESS
} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';

import {
    DeleteBusinessProcessParameters,
    DeleteBusinessProcessResult
} from '~/shared/src/utilities/modules/businessProcess';
import {clearElusiveData} from '~/frontend/src/actions/elusiveData';
import xhr from '~/frontend/src/utilities/xhr';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {number} businessProcessId
 * @param {( responseData : DeleteBusinessProcessResult ) => void} [successCallback]
 *
 * @return {Promise<DeleteBusinessProcessResult | false>}
 */
const deleteBusinessProcess = ( panelKey : string, businessProcessId : number, successCallback? : ( responseData : DeleteBusinessProcessResult ) => void ) : Thunk<Promise<DeleteBusinessProcessResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<DeleteBusinessProcessResult | false> => {
    dispatch( {
        type: BUSINESSPROCESSDESIGNER_DELETE_BUSINESSPROCESS,
        panelKey,
        businessProcessId
    } );

    let retVal : DeleteBusinessProcessResult | false = false;

    dispatch( clearElusiveData( panelKey ) );

    const params : DeleteBusinessProcessParameters = {
              viewId: businessProcessId
          },
          response                          = await xhr.post(
              `${BASE_URL}/api/businessProcess/deleteBusinessProcess`,
              params,
              undefined,
              panelKey,
              'deleteBusinessProcess',
              dispatch
          );

    if ( response?.data.success && !response.data.errorTitle ) {
        if ( successCallback ) {
            successCallback( response.data as DeleteBusinessProcessResult );
        }

        retVal = response.data as DeleteBusinessProcessResult;
    }

    return retVal;
};
export type DeleteBusinessProcess = typeof deleteBusinessProcess;

export default deleteBusinessProcess;
